interface SEOWebPageProps {
  title: string;
  description: string;
  url: string;
  type?: string;
  datePublished?: string;
  dateModified?: string;
  breadcrumbItems?: { name: string; url: string }[];
}

export function SEOWebPage({
  title,
  description,
  url,
  type = 'WebPage',
  datePublished,
  dateModified,
  breadcrumbItems,
}: SEOWebPageProps) {
  const ldJson: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': type,
    name: title,
    description,
    url,
  };
  if (datePublished) ldJson.datePublished = datePublished;
  if (dateModified) ldJson.dateModified = dateModified;
  if (breadcrumbItems) {
    ldJson.breadcrumb = {
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems.map((item, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: item.name,
        item: item.url,
      })),
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }}
    />
  );
}

interface SEOArticleProps {
  title: string;
  description: string;
  url: string;
  author: string;
  datePublished: string;
  dateModified: string;
  imageUrl: string;
  breadcrumbItems: { name: string; url: string }[];
}

export function SEOArticle({
  title,
  description,
  url,
  author,
  datePublished,
  dateModified,
  imageUrl,
  breadcrumbItems,
}: SEOArticleProps) {
  const ldJson = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    url,
    author: { '@type': 'Person', name: author },
    datePublished,
    dateModified,
    image: imageUrl,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems.map((item, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: item.name,
        item: item.url,
      })),
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }}
    />
  );
}

interface SEOFAQProps {
  faqs: { question: string; answer: string }[];
}

export function SEOFAQ({ faqs }: SEOFAQProps) {
  const ldJson = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }}
    />
  );
}

export function SEOOrganization() {
  const ldJson = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51漫画网',
    url: 'https://ytzshn.cn',
    description: '洞洞杂货铺韩漫全集免费阅读平台，提供高清韩漫在线观看',
    logo: 'https://ytzshn.cn/logo.png',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@ytzshn.cn',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }}
    />
  );
}